import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiChannel } from 'core/constants';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';
import { LineBannerInfo } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class LineBannerApi {
    public static getLineBannerInfo(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<LineBannerInfo> {
        return http.get(`/lines/${params.lineId}/herobanner`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: LineBannerInfo) => {
                response.lineId = params.lineId;

                return LineBannerInfo.create<LineBannerInfo>(response);
            })
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_LINE_BANNER_INFO] = LineBannerApi.getLineBannerInfo;
